export const REDUX_GET_CSV_IMPORT_TABLE_SCHEMAS = 'REDUX_GET_CSV_IMPORT_TABLE_SCHEMAS'
export const REDUX_GET_CSV_IMPORT_SCHEMA = 'REDUX_GET_CSV_IMPORT_SCHEMA'
